module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "flexday-suite-selected.8bf617a1.svg";